import React,{ useEffect, useRef } from 'react';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import Close from '@material-ui/icons/Close';
import Check from '@material-ui/icons/Check';
import jsonExport from 'jsonexport/dist';
import { List, Datagrid, TextField, ReferenceField, DateField, Pagination, DateInput,AutocompleteInput,
    Filter, Show, TextInput, SimpleShowLayout, FunctionField, useRefresh,
    ReferenceInput, SelectInput, DeleteButton } from 'react-admin';
import {GMapGrid}  from '../maps/gmapList';

function useRecursiveTimeout(callback, delay) { 
    const savedCallback = useRef(callback)

    useEffect(() => {
      savedCallback.current = callback  
    }, [callback])

    useEffect(() => { 
      let id    
      function tick() {
        const ret = savedCallback.current()

        if (ret instanceof Promise) {
          ret.then(() => {
            if (delay !== null) {
              id = setTimeout(tick, delay)
            }
          })
        } else {
          if (delay !== null) {
            id = setTimeout(tick, delay)
          }
        }
      }
      if (delay !== null) {
        id = setTimeout(tick, delay)
        return () => id && clearTimeout(id)
      }
    }, [delay])
  }

const LocationsMapFilter = ({permissions, ...props}) => (
        <Filter {...props}>
            <TextInput label="Search" source="q" alwaysOn disabled = {permissions !== 'admin'}/>
            <SelectInput source="status" choices={[
                { id: 'InProgress', name: 'In Progress' },
                { id: 'Finished', name: 'Finished' },
                { id: 'DNF', name: 'DNF' },
            ]} alwaysOn disabled/>
           {(permissions === 'admin' || props.filterValues.track__site) &&
            <ReferenceInput label="Site Name" alwaysOn = {permissions !== 'admin'}
           perPage = {10000} disabled = {permissions !== 'admin'}
            source="track__site" reference="sites"  sort={{ field: 'name', order: 'ASC' }}>
                <AutocompleteInput optionText="name" />
            </ReferenceInput>
            }
            { ((permissions === 'admin' && props.filterValues.track__site) || props.filterValues.track) &&
                <ReferenceInput label="Course Name" source="track" alwaysOn = {permissions !== 'admin'}
                key={props.filterValues.track__site}
                disabled = {permissions !== 'admin'}
                reference="tracks" filter={{site: props.filterValues.track__site, page_size: 10000}} sort={{ field: 'title', order: 'ASC' }}>
                    <AutocompleteInput optionText="title" />
                </ReferenceInput>
            }
            {(permissions === 'admin' || props.filterValues.user__full_name) &&
            <TextInput label="UserName" source="user__full_name" alwaysOn = {permissions !== 'admin'} disabled = {permissions !== 'admin'}/>
          }
          {(permissions === 'admin' || props.filterValues.date) &&
            <DateInput label="Date" source="date" alwaysOn = {permissions !== 'admin'} disabled = {permissions !== 'admin'}/>
        }
          </Filter>
    );

const LocationsMapPagination = props => <Pagination rowsPerPageOptions={[10, 25, 50, 100, 200, 1000]} {...props} />;

export const LocationMapList = ({permissions, ...props}) =>{ 
    return(
    <List {...props} title="Locations Map" perPage={1000} 
    exporter={permissions === 'admin' ? undefined : false}
    filters={<LocationsMapFilter permissions={permissions}/>} pagination={<LocationsMapPagination />} filterDefaultValues={{ status: 'InProgress' }}>
        <GMapGrid {...props}/>
    </List>
)};